<div class="mat-dialog-container">
  <!-- 明細編輯開始 -->
  <div #head>
    <app-modal-header #modal_header [isDialog]="isDialog" [title]="title" [state]="srv.state" (onOkClick)="doOk($event)"
      (onEditAndSaveClick)="doEditAndSave($event)"
      (onCancelClick)="doCancel($event)">
    </app-modal-header>
  </div>
  <div class="jk-content">
    <div > 
    <app-jkedit  label="廠商代號" #VENDORCom  id="VENDOR"  [(value)]="item.VENDOR" placeholder="廠商代號"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jkedit  label="員工編號" #WA013Com  id="WA013"  [(value)]="item.WA013" placeholder="員工編號"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jkedit  label="主管代號" #WA011Com  id="WA011"  [(value)]="item.WA011" placeholder="主管代號"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jkedit  label="主要代理人" #WA010Com  id="WA010"  [(value)]="item.WA010" placeholder="主要代理人"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jkedit  label="部門代號" #WA009Com  id="WA009"  [(value)]="item.WA009" placeholder="部門代號"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jkedit  label="登入者代號" #UserIDCom  id="UserID"  [(value)]="item.UserID" [required]="true"  placeholder="登入者代號"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jkedit  label="代理人員工號" #WA016Com  id="WA016"  [(value)]="item.WA016" placeholder="代理人員工號"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jkedit  label="客戶代號" #CUSTOMERCom  id="CUSTOMER"  [(value)]="item.CUSTOMER" placeholder="客戶代號"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jkedit  label="E-Mail帳號" #EMAILCom  id="EMAIL"  [(value)]="item.EMAIL" placeholder="E-Mail帳號"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jkedit  label="可登入公司" #PSCom  id="PS"  [(value)]="item.PS" placeholder="可登入公司"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jkedit  label="密碼" #PasswordCom  id="Password"  [(value)]="item.Password" placeholder="密碼"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jkedit  label="登入者名稱" #UserNameCom  id="UserName"  [(value)]="item.UserName" placeholder="登入者名稱"  [readonly]="isBrowse"     >
    </app-jkedit>
    <app-jkdatefield  label="停用日期" #WA012Com  id="WA012"  [(value)]="item.WA012" placeholder="停用日期"  [readonly]="isBrowse" 
            >
    </app-jkdatefield>
    <app-jkdatefield  label="起始代理日期" #WA014Com  id="WA014"  [(value)]="item.WA014" placeholder="起始代理日期"  [readonly]="isBrowse" 
            >
    </app-jkdatefield>
    <app-jkdatefield  label="結束代理日期" #WA015Com  id="WA015"  [(value)]="item.WA015" placeholder="結束代理日期"  [readonly]="isBrowse" 
            >
    </app-jkdatefield>
    <app-jkdatefield  label="最後登入時間" #WA008Com  id="WA008"  [(date)]="item.WA008" placeholder="最後登入時間"  [readonly]="isBrowse" 
            >
    </app-jkdatefield>

    </div>
  </div>
</div>